import React from 'react';
import PropTypes from 'prop-types';
import { RouteLink } from 'core/components';
import { IconLogo } from 'components/icons/icon-logo/icon-logo';
import { IconLogoSmall } from 'components/icons/icon-logo-small/icon-logo-small';

export const Logo = ({
  className,
  iconClassName,
  isMobile,
  isDarkTheme
}) => (
  <RouteLink className={className} to="/">
    {isMobile
      ? <IconLogoSmall className={iconClassName} isDarkTheme={isDarkTheme} />
      : <IconLogo className={iconClassName} />}
  </RouteLink>
);

Logo.propTypes = {
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  isMobile: PropTypes.bool,
  isDarkTheme: PropTypes.bool,
};

Logo.defaultProps = {
  className: '',
  iconClassName: '',
  isMobile: false,
  isDarkTheme: false,
};
